import React, { useEffect } from 'react';
import About from './components/About';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Expertise from './components/Expertise';
import Regions from './components/Regions';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

const App = () => {
  useEffect(() => {
    const header = document.getElementById('site-header');
  
    header.style.transform = 'translateY(0%)';
  
    const hoverZone = document.createElement('div');
    hoverZone.style.position = 'fixed';
    hoverZone.style.top = '0';
    hoverZone.style.left = '0';
    hoverZone.style.right = '0';
    hoverZone.style.height = '30px';
    hoverZone.style.zIndex = '9999';
    document.body.appendChild(hoverZone);
  
    let isHoveringHeader = false;
  
    const handleScroll = () => {
      if (window.scrollY < 50 || isHoveringHeader) {
        header.style.transform = 'translateY(0%)';
      } else {
        header.style.transform = 'translateY(-100%)';
      }
    };
  
    const showHeader = () => {
      header.style.transform = 'translateY(0%)';
    };
  
    const hideHeader = () => {
      if (!isHoveringHeader && window.scrollY >= 50) {
        header.style.transform = 'translateY(-100%)';
      }
    };
  
    header.addEventListener('mouseenter', () => {
      isHoveringHeader = true;
      showHeader();
    });
  
    header.addEventListener('mouseleave', () => {
      isHoveringHeader = false;
      hideHeader();
    });
  
    hoverZone.addEventListener('mouseenter', showHeader);
    hoverZone.addEventListener('mouseleave', hideHeader);
    window.addEventListener('scroll', handleScroll);
  
    return () => {
      document.body.removeChild(hoverZone);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  

  return (
    <div
      style={{
        fontFamily: "'Poppins', sans-serif",
        color: '#333',
        backgroundColor: '#f9f9f9',
        overflowX: 'hidden',
        overflowY: 'auto',
        height: '100%'
      }}
    >
      <div id="top">
        <Header />
        <Hero />
        <Services />
        <Expertise />
        <Regions />
        <About />
        <Contact />
        <Footer />
        <ScrollToTop />
      </div>
    </div>
  );
};

export default App;
